import { PropsWithChildren } from "react";
import styled from "styled-components";

const Container = styled.div<{ width: number }>`
  display: none;
  padding-top: 10px;
  font-weight: 500;
  font-style: italic;

  @media (max-width: ${(props) => props.width}px) {
    display:block
  }
`;

interface ResponsiveContentProps {
    minWidth: number
}
export const ResponsiveContent = ({
    children,
    minWidth
}: PropsWithChildren<ResponsiveContentProps>) => {
    return <Container width={minWidth}>{children}</Container>;
};
